import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ForgotPasswordService} from '../../../services/forgot-password.service';
import {Router} from '@angular/router';
import {
  INVALID_OTP_VALIDATION_ERROR_CODE,
  ValidationErrorResponse
} from '../../../../shared/models/validation-error-response';

@Component({
  selector: 'app-submit-confirmation-code-form',
  templateUrl: './submit-confirmation-code-form.component.html',
  styleUrls: [
    './submit-confirmation-code-form.component.css',
    '../../../../../assets/css/floating-labels.css'
  ]
})
export class SubmitConfirmationCodeFormComponent implements OnInit {

  submitConfirmationCodeButtonClicked = false;
  submitConfirmationCodeErrorType: string;

  @Input()
  public username: string;

  submitConfirmationCodeForm = new FormGroup({
    confirmationCodeInput: new FormControl('', [Validators.required])
  });

  constructor(private forgotPasswordService: ForgotPasswordService, private router: Router) {}

  ngOnInit(): void {
  }

  submitConfirmationCode(): void {
    console.log('Submitting confirmation code...');
    this.submitConfirmationCodeButtonClicked = true;

    if (!this.submitConfirmationCodeForm.valid || this.username == null) {
      return;
    }

    this.forgotPasswordService.validateOneTimePassword(this.username,
      this.submitConfirmationCodeForm.controls.confirmationCodeInput.value).subscribe(validationResponse => {
        if (validationResponse == null) {
          // navigate to reset password page
          this.router.navigate(['/reset-password'], {
            state: {
              username: this.username,
              otp: this.submitConfirmationCodeForm.controls.confirmationCodeInput.value
            }
          });
        } else {
          if (this.containsInvalidOtpValidationError(validationResponse)) {
            this.submitConfirmationCodeErrorType = 'INVALID_CODE';
          } else {
            this.submitConfirmationCodeErrorType = 'GENERIC_ERROR';
          }
        }
    },
    error => {
      this.submitConfirmationCodeErrorType = 'GENERIC_ERROR'; // show error when server is not reached
    });
  }

  public setSubmitConfirmationCodeErrorType(submitConfirmationCodeErrorType: string): void {
    this.submitConfirmationCodeErrorType = submitConfirmationCodeErrorType;
  }

  public containsInvalidOtpValidationError(validationResponse: ValidationErrorResponse): boolean {
    for (const validationError of validationResponse?.errors) {
      if (validationError.code === INVALID_OTP_VALIDATION_ERROR_CODE) {
        return true;
      }
    }
    return false;
  }
}
